import { watchDebounced } from '@vueuse/core'
import _ from "underscore";
import { computed, ref, unref, watch } from "vue";

import { useLoadingStore } from "@/stores/loading";
import { useNotificationsStore } from "@/stores/notifications";

import useAxios from './axios.js'

export default async function useDataTable({ endpoint, perPage = 20, sortStatus, search, searchProperties = [], extraFilter = () => true, mockData = null }) {

  const loadingStore = useLoadingStore()
  const notificationsStore = useNotificationsStore()
  const axios = useAxios()

  const all = ref([])
  const filtered = ref([])
  const visible = ref([]);
  const currentPage = ref(1);
  const totalPages = ref(0)

  const countVisible = computed(() => {
    return visible.value.length;
  })

  const countFiltered = computed(() => {
    return filtered.value.length;
  })

  const countAll = computed(() => {
    return all.value.length;
  })

  //refresh all data
  const initData = async () => {
    const resp = await axios.get(endpoint);
    all.value = mockData ?? resp.data;
    filtered.value = mockData ?? resp.data;
    currentPage.value = 1;
    refreshPagination()
  }

  //refresh all data keeping filter
  const refreshDataWithFilter = async () => {
    const resp = await axios.get(endpoint);
    all.value = resp.data;
    doFilter()
  }

  const next = function () {
    currentPage.value++
  }

  const prev = function () {
    currentPage.value--
  }

  const hasPrev = computed(() => {
    return currentPage.value > 1;
  })

  const hasNext = computed(() => {
    return filtered.value.length > 0 && currentPage.value < totalPages.value;
  })

  const refreshPagination = () => {
    totalPages.value = Math.ceil(filtered.value.length / perPage)
    visible.value = filtered.value.slice((currentPage.value - 1) * perPage, currentPage.value * perPage)
  }

  const doFilter = () => {
    let original = unref(all.value)
    original = original.filter((item) => {
      const searchMatched = (
        search.value === '' || item.uuid === search.value || _.some(searchProperties, (searchProperty) => {
          return item[searchProperty] ? item[searchProperty].toLowerCase().indexOf(search.value.toLowerCase()) !== -1 : false;
        })
      );
            
      return searchMatched && extraFilter(item, search)
    });
    filtered.value = original
    currentPage.value = 1
    refreshPagination()
  }

  watch(sortStatus, () => {
    let original = unref(all.value)
    original = _.sortBy(original, sortStatus.value[0])
    if (sortStatus.value[1] === 1) {
      original = original.reverse();
    }

    filtered.value = original
    currentPage.value = 1
    refreshPagination()
  })

  watch(currentPage, refreshPagination)

  watchDebounced(search, () => {
    if (search.value.length == 0) {
      filtered.value = all.value;
      refreshPagination()
      return
    }

    doFilter()
  }, 200)

  const action = (method, endpoint, message) => {
    if (!window.confirm('Sei sicuro?')) {
      return;
    }

    loadingStore.withLoading(async () => {
      try {
        await axios[method](endpoint);
        notificationsStore.pushSuccess(message)
      } catch(error) {

        await refreshDataWithFilter()
      }
    })
  }

  await initData()

  return { data: visible, count: countVisible, countFiltered, countAll, currentPage, totalPages, next, prev, hasPrev, hasNext, doFilter, action }
}

